import React from 'react';

const EmptySkillsImage: React.FC = () => {
  return <img src="/images/emptySkills.svg" alt="No skills found" />;
};

export default EmptySkillsImage;
